import { useTranslation } from 'react-i18next';

export default function LanguageToggle() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage || 'tr';
  const set = (lng) => i18n.changeLanguage(lng);
  return (
    <div className="lang-toggle" role="group" aria-label="language">
      <button className={current === 'tr' ? 'active' : ''} onClick={() => set('tr')}>TR</button>
      <button className={current === 'en' ? 'active' : ''} onClick={() => set('en')}>EN</button>
    </div>
  );
}
